// Generated by scripts/build-sticky-runtime.mjs from the existing Bossco sticky cart runtime.
// Theme-only landing integration; retain native submissions, the app singleton and existing embed controls.
(function () {
  'use strict';
  const doc = document;
  // The editor gets a Liquid-rendered preview, without live DOM observers or cart hooks.
  if (window.Shopify?.designMode || doc.querySelector('[data-sticky-editor]')) return;
  const key = '__bosscoStickyCart';
  if (window[key]) { window[key].boot(); return; }
  const selector = '[data-bossco-sticky-cart]';
  const formSelector = 'form.product-purchase-form';
  const landingSelector = '[data-bc-landing], [data-bc-accessory-landing], [data-bc-roof-rack-landing], [data-bc-drawer-landing], [data-bc-package-landing], [data-bc-roller-landing], [data-bc-electric-landing]';
  const chooseLabel = 'Choose options';
  const find = (root, name) => root.querySelector(`[data-sticky-${name}]`);
  let instance;

  const text = (node) => (node?.textContent || '').replace(/\s+/g, ' ').trim();
  const set = (node, name, value) => { if (node[name] !== value) node[name] = value; };
  const setText = (node, value) => set(node, 'textContent', value);
  const attr = (node, name, value) => { if (node.getAttribute(name) !== value) node.setAttribute(name, value); };
  const css = (node, name, value) => { if (node.style.getPropertyValue(name) !== value) node.style.setProperty(name, value); };
  const visible = (node) => !!node?.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';

  class StickyCart {
    constructor(root) {
      this.__root = root;
      this.__prices = JSON.parse(find(root, 'prices')?.textContent || 'null');
      this.__events = new AbortController();
      this.__panel = find(root, 'panel');
      this.__options = find(root, 'options');
      this.__toggle = find(root, 'toggle');
      this.__add = find(root, 'add');
      this.__status = find(root, 'status');
      this.__groups = [];
      this.__spacer = doc.createElement('div');
      this.__spacer.dataset.stickySpacer = '';
      this.__spacer.setAttribute('aria-hidden', 'true');
      root.after(this.__spacer);
      this.__listen(this.__toggle, 'click', () => this.__open(this.__panel.hidden, true));
      this.__listen(find(root, 'close'), 'click', () => this.__open(false, true));
      this.__listen(find(root, 'source'), 'click', () => this.__revealSource());
      this.__listen(this.__add, 'click', () => this.__submit());
      this.__listen(root, 'keydown', (event) => {
        if (event.key === 'Escape' && !this.__panel.hidden) { event.preventDefault(); this.__open(false, true); }
      });
      this.__listen(doc, 'click', (event) => {
        if (!this.__choosing && !this.__panel.hidden && !root.contains(event.target)) this.__open(false);
      });
      ['scroll', 'resize'].forEach((name) => this.__listen(window, name, () => this.__scheduleVisibility(), { passive: true }));
      ['pageshow', 'load', 'popstate'].forEach((name) => this.__listen(window, name, () => this.__schedule()));
      ['change', 'input'].forEach((name) => this.__listen(doc, name, (event) => {
        if ((this.__scope?.contains(event.target) || this.__landingPanel?.contains(event.target)) && !root.contains(event.target)) this.__schedule();
      }));
      if (window.visualViewport) {
        ['resize', 'scroll'].forEach((name) => this.__listen(window.visualViewport, name, () => this.__scheduleVisibility(), { passive: true }));
      }
      this.__listen(doc, 'theme:cartchanged', () => {
        if (this.__pending) { this.__finish(); setText(this.__status, 'Added to cart'); this.__open(false); }
        this.__scheduleVisibility();
      });
      ['load', 'unload'].forEach((name) => this.__listen(doc, `shopify:section:${name}`, () => this.__schedule()));
      this.__pageObserver = new MutationObserver((records) => {
        if (!root.isConnected) { this.__destroy(); return; }
        // Rebind both source controls and threshold when a landing section changes.
        if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(landingSelector) || node.matches('[data-bc-purchase]') || node.querySelector(landingSelector) || node.querySelector('[data-bc-purchase]'))))) this.__schedule();
        // Editor updates unrelated to the product must not repeatedly scan the page.
        if (!this.__form?.isConnected && records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === 1 && (node.matches(formSelector) || node.querySelector(formSelector))))) this.__schedule();
        if (this.__pending) {
          for (const record of records) {
            for (const node of record.addedNodes) {
              if (node.nodeType !== 1 || root.contains(node)) continue;
              const error = node.matches('.simple-popup.error') ? node : node.querySelector('.simple-popup.error');
              if (error && text(error)) { this.__finish(); setText(this.__status, text(error)); }
            }
          }
        }
      });
      this.__pageObserver.observe(doc.body, { childList: true, subtree: true });
      this.__overlayObserver = new MutationObserver((records) => {
        if (records.some((record) => record.target.matches('html, body, .cc-popup, dialog'))) this.__scheduleVisibility();
      });
      this.__overlayObserver.observe(doc.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.__overlayObserver.observe(doc.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
      this.__sync();
    }

    __listen(target, name, callback, options = {}) {
      target?.addEventListener(name, callback, { ...options, signal: this.__events.signal });
    }

    __bindForm() {
      const id = this.__root.dataset.productId;
      const form = [...doc.querySelectorAll(formSelector)].find((candidate) => {
        const wrapper = candidate.closest('.product-form');
        return (candidate.dataset.productId || wrapper?.dataset.productId) === id &&
          !candidate.closest('.quickbuy-modal, .quickbuy-container, .cc-popup, [data-bossco-sticky-cart]') && visible(candidate);
      });
      if (!form) { set(this.__root, 'hidden', true); return false; }
      if (form !== this.__form) {
        this.__formObserver?.disconnect();
        this.__resizeObserver?.disconnect();
        this.__form = form;
        this.__scope = form.closest('.product-form') || form;
        this.__product = form.closest('.product-detail') || this.__scope;
        this.__buyRow = form.closest('.buy-buttons-row') || form;
        // A preview can nest the embed inside the product section. Ignore our own writes.
        this.__formObserver = new MutationObserver((records) => {
          if (records.some((record) => !this.__root.contains(record.target) && record.target !== this.__spacer)) this.__schedule();
        });
        this.__formObserver.observe(this.__scope, { subtree: true, childList: true, characterData: true, attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'aria-selected', 'checked', 'selected', 'value', 'class'] });
        // Variant status belongs to .product-detail, outside .product-form in Mode.
        if (this.__product !== this.__scope) this.__formObserver.observe(this.__product, { attributes: true, attributeFilter: ['class'] });
        if (window.ResizeObserver) {
          this.__resizeObserver = new ResizeObserver(() => this.__scheduleVisibility());
          this.__resizeObserver.observe(this.__buyRow);
        }
        this.__signature = '';
      }
      this.__nativeAdd = this.__form.querySelector('button[type="submit"], input[type="submit"]');
      if (!this.__nativeAdd) { set(this.__root, 'hidden', true); return false; }
      if (!this.__jquery && window.jQuery) {
        this.__jquery = window.jQuery;
        this.__variantListener = (_event, data) => {
          if (!data?.product || String(data.product.id) === id) this.__schedule();
        };
        this.__jquery(window).on('cc-variant-updated.bosscoStickyCart', this.__variantListener);
      }
      return true;
    }

    __readGroups() {
      if (this.__default) return [];
      const panel = this.__landingPanel;
      if (panel && this.__landingAdd && visible(this.__landingAdd)) {
        let controls = [...panel.querySelectorAll('select[data-bc-option-index]')].filter(visible);
        if (!controls.length) controls = [...panel.querySelectorAll('select[data-bc-variant]')].filter(visible);
        if (controls.length) return controls.map((select, index) => {
          const labelCopy = select.labels?.[0]?.cloneNode(true);
          labelCopy?.querySelectorAll('select').forEach((node) => node.remove());
          return { __label: text(labelCopy).replace(/:\s*$/, '') || (controls.length === 1 ? 'Options' : 'Option ' + (index + 1)),
            __selected: select.value, __type: 'select', __source: select,
            __values: Array.from(select.options, (option) => ({ value: option.value, __label: text(option), disabled: option.disabled })) };
        });
      }
      const result = [];
      this.__scope.querySelectorAll('.option-selectors .option-selector').forEach((group, index) => {
        const labelNode = group.querySelector('legend, .label');
        const labelCopy = labelNode?.cloneNode(true);
        labelCopy?.querySelectorAll('.label__value, .label__prefix').forEach((node) => node.remove());
        const label = text(labelCopy).replace(/:\s*$/, '') || `Option ${index + 1}`;
        const select = group.querySelector('select');
        const radios = [...group.querySelectorAll('input[type="radio"]')];
        const choices = [...group.querySelectorAll('[role="option"][data-value]')];
        if (select) {
          result.push({ __label: label, __selected: select.value, __type: 'select', __source: select,
            __values: Array.from(select.options, (option) => ({ value: option.value, __label: text(option), disabled: option.disabled })) });
        } else if (radios.length) {
          result.push({ __label: label, __selected: radios.find((radio) => radio.checked)?.value || '', __type: 'radio', __sources: radios,
            __values: radios.map((radio) => ({ value: radio.value, __label: radio.value, disabled: radio.disabled })) });
        } else if (choices.length) {
          result.push({ __label: label, __selected: choices.find((choice) => choice.getAttribute('aria-selected') === 'true')?.dataset.value || '', __type: 'custom', __sources: choices,
            __values: choices.map((choice) => ({ value: choice.dataset.value, __label: choice.dataset.value || text(choice), disabled: choice.getAttribute('aria-disabled') === 'true' })) });
        }
      });
      // Mode can also render a single native variant dropdown with combined option labels.
      if (result.length < Number(this.__root.dataset.optionCount)) {
        const select = this.__form.querySelector('select[name="id"]');
        if (select) { result.length = 0; result.push({ __label: 'Options', __selected: select.value, __type: 'select', __source: select,
          __values: Array.from(select.options, (option) => ({ value: option.value, __label: text(option), disabled: option.disabled })) }); }
      }
      return result;
    }

    __renderOptions() {
      this.__groups = this.__readGroups();
      const signature = JSON.stringify(this.__groups.map(({ __label, __values }) => ({ __label, __values })));
      if (signature !== this.__signature) {
        const activeIndex = [...this.__options.querySelectorAll('select')].indexOf(doc.activeElement);
        this.__options.replaceChildren();
        this.__groups.forEach((group, index) => {
          const label = doc.createElement('label');
          label.className = 'bossco-sticky-cart__option';
          const name = doc.createElement('span');
          name.textContent = group.__label;
          const select = doc.createElement('select');
          select.dataset.stickyOption = index;
          select.setAttribute('aria-label', group.__label);
          if (!group.__values.some((value) => value.value === '')) {
            const placeholder = new Option(`Choose ${group.__label.toLowerCase()}`, '');
            placeholder.disabled = true;
            select.add(placeholder);
          }
          group.__values.forEach((value) => {
            const option = new Option(value.__label, value.value);
            option.disabled = value.disabled;
            select.add(option);
          });
          select.addEventListener('change', () => this.__choose(index, select.value));
          label.append(name, select);
          this.__options.append(label);
        });
        this.__signature = signature;
        if (activeIndex >= 0) this.__options.querySelectorAll('select')[activeIndex]?.focus({ preventScroll: true });
      }
      this.__options.querySelectorAll('select').forEach((select, index) => set(select, 'value', this.__groups[index].__selected));
      set(this.__toggle, 'hidden', this.__default);
      if (this.__toggle.hidden) this.__open(false);
      [...find(this.__root, 'summary').children].forEach((pair, index) => {
        const group = this.__groups[index];
        set(pair, 'hidden', !group);
        if (group) {
          setText(pair.children[0], `${group.__label}:`);
          setText(pair.children[1], group.__values.find((value) => value.value === group.__selected)?.__label || chooseLabel);
        }
      });
    }

    __choose(index, value) {
      // Resolve fresh DOM references after any theme variant re-render.
      const group = this.__readGroups()[index];
      if (!group) { this.__schedule(); return; }
      setText(this.__status, '');
      const focused = doc.activeElement;
      const scrollY = window.scrollY;
      this.__choosing = true;
      if (group.__type === 'select') {
        group.__source.value = value;
        group.__source.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const choice = group.__sources.find((source) => (group.__type === 'radio' ? source.value : source.dataset.value) === value);
        if (!choice) { this.__choosing = false; return; }
        if (group.__type === 'custom') choice.closest('.cc-select')?.dispatchEvent(new CustomEvent('selectOption', { detail: { value } }));
        else choice.click();
      }
      this.__choosing = false;
      // Mode's custom dropdown returns focus to its off-screen trigger on selection.
      focused?.focus({ preventScroll: true });
      if (window.scrollY !== scrollY) window.scrollTo({ top: scrollY, behavior: 'instant' });
      this.__sync();
    }

    __sync() {
      if (this.__destroyed || !this.__bindForm()) return;
      this.__landingHero();
      this.__default = this.__root.dataset.hasOnlyDefaultVariant === 'true';
      this.__renderOptions();
      const native = this.__nativeAdd;
      const displayButton = this.__landingAdd && visible(this.__landingAdd) ? this.__landingAdd : native;
      const invalid = this.__landingPanel?.dataset.bcInvalid === 'true';
      const style = getComputedStyle(displayButton);
      const background = getComputedStyle(doc.body);
      const vars = {
        'button-background': style.backgroundColor,
        'button-text': style.color,
        'button-border': style.borderTopColor,
        'button-radius': style.borderTopLeftRadius,
        'button-weight': style.fontWeight,
        'text': background.color,
        'background': background.backgroundColor === 'rgba(0, 0, 0, 0)' ? '#fff' : background.backgroundColor,
      };
      Object.entries(vars).forEach(([name, value]) => css(this.__root, `--sticky-${name}`, value));
      // The selected purchase variant is authoritative even without a native price block.
      const price = invalid ? '' : this.__prices
        ? this.__prices[this.__form.elements.namedItem('id')?.value] || ''
        : text(this.__scope.querySelector('.price-area .current-price'));
      setText(find(this.__root, 'price'), price);
      this.__missing = this.__groups.some((group) => !group.__selected);
      const unavailable = this.__product.classList.contains('variant-status--unavailable');
      set(this.__add, 'disabled', !!(this.__pending || invalid || native.disabled || displayButton.disabled || native.getAttribute('aria-disabled') === 'true' || displayButton.getAttribute('aria-disabled') === 'true' || unavailable));
      attr(this.__add, 'aria-busy', String(!!this.__pending || native.classList.contains('btn--in-progress') || displayButton.getAttribute('aria-busy') === 'true'));
      const purchaseLabel = text(displayButton.querySelector('[data-bc-add-label]')) || text(displayButton) || displayButton.value;
      setText(this.__add, this.__pending ? 'Adding…' : this.__missing ? chooseLabel : purchaseLabel || (invalid ? 'Unavailable combination' : 'Add to cart'));
      this.__updateVisibility();
    }

    __open(open, focus = false) {
      set(this.__panel, 'hidden', !open);
      attr(this.__toggle, 'aria-expanded', String(open));
      if (focus) (open ? this.__options.querySelector('select') : this.__toggle)?.focus({ preventScroll: true });
    }

    __revealSource() {
      this.__open(false);
      this.__landingHero();
      const panel = this.__landingPanel && visible(this.__landingPanel) ? this.__landingPanel : null;
      const source = panel || this.__scope;
      source?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const control = panel
        ? [...panel.querySelectorAll('select[data-bc-option-index], select[data-bc-variant]')].find(visible) || this.__landingAdd
        : this.__scope?.querySelector('.option-selectors button, .option-selectors input, .option-selectors select') || this.__nativeAdd;
      control?.focus({ preventScroll: true });
    }

    __submit() {
      if (this.__pending) return;
      this.__sync();
      if (!this.__form?.isConnected || !this.__nativeAdd || this.__add.disabled) return;
      if (this.__missing) { setText(this.__status, 'Choose your options before adding to cart.'); this.__open(true, true); return; }
      if (!this.__groups.length && !this.__default) { this.__revealSource(); return; }
      // Preserve all native fields and handlers: quantity, properties, preorder selling plan and cart drawer.
      if (!this.__form.checkValidity()) { this.__revealSource(); this.__form.reportValidity(); return; }
      this.__pending = true;
      setText(this.__status, '');
      this.__sync();
      this.__nativeAdd.click();
      this.__timeout = window.setTimeout(() => {
        if (this.__pending) {
          this.__finish();
          setText(this.__status, 'Check your cart before trying again.');
        }
      }, 15000);
    }

    __finish() {
      this.__pending = false;
      clearTimeout(this.__timeout);
      this.__schedule();
    }

    __schedule() {
      if (this.__frame || this.__destroyed) return;
      this.__frame = requestAnimationFrame(() => { this.__frame = 0; this.__sync(); });
    }

    __scheduleVisibility() {
      if (this.__visibilityFrame || this.__destroyed) return;
      this.__visibilityFrame = requestAnimationFrame(() => { this.__visibilityFrame = 0; this.__updateVisibility(); });
    }

    __landingHero() {
      const hero = [...doc.querySelectorAll(landingSelector)].find((node) =>
        node.querySelector('[data-bc-purchase]')?.dataset.productId === this.__root.dataset.productId && visible(node));
      const panel = hero?.querySelector('[data-bc-purchase]');
      const add = panel?.querySelector('[data-bc-add]');
      if (hero !== this.__hero || panel !== this.__landingPanel || add !== this.__landingAdd) {
        this.__heroResizeObserver?.disconnect();
        this.__landingObserver?.disconnect();
        this.__hero = hero;
        this.__landingPanel = panel;
        this.__landingAdd = add;
        if (hero && window.ResizeObserver) {
          this.__heroResizeObserver = new ResizeObserver(() => this.__scheduleVisibility());
          this.__heroResizeObserver.observe(hero);
          if (add) this.__heroResizeObserver.observe(add);
        }
        if (panel) {
          // Only read the hero. Sticky writes occur in its own embed, outside this panel.
          this.__landingObserver = new MutationObserver((records) => {
            if (records.some((record) => !this.__root.contains(record.target) && record.target !== this.__spacer)) this.__schedule();
          });
          this.__landingObserver.observe(panel, { subtree: true, childList: true, characterData: true, attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'data-bc-invalid'] });
        }
      }
      return hero;
    }

    __updateVisibility() {
      const mobile = window.innerWidth < 750;
      const allowed = this.__root.dataset[mobile ? 'mobile' : 'desktop'] !== 'false';
      const overlay = doc.documentElement.matches('.js-drawer-open, .cc-popup-visible, .header-overlay-open, .gallery-viewer-open') ||
        doc.body.matches('.js-drawer-open, .cc-popup-visible') || doc.querySelector('.cc-popup--visible, dialog[open]');
      const viewport = window.visualViewport;
      // Avoid covering the on-screen keyboard or floating into a pinch-zoomed viewport.
      const keyboard = viewport && (viewport.scale > 1.05 || window.innerHeight - viewport.height > 150);
      if (viewport) css(this.__root, '--sticky-viewport-height', `${Math.round(viewport.height)}px`);
      const hero = this.__landingHero();
      const buy = this.__buyRow?.getBoundingClientRect();
      const hiddenSource = !!this.__form?.closest('[data-bc-native-purchase-source]');
      const heroAdd = this.__landingAdd;
      // Integrated heroes use their visible buy button, never the clipped native source.
      // Original landings keep the hero threshold and suppress sticky at the native buy row.
      const passedTrigger = hiddenSource
        ? !!heroAdd && visible(heroAdd) && heroAdd.getBoundingClientRect().bottom <= 0
        : !!buy && (hero
          ? hero.getBoundingClientRect().bottom <= 0 && (buy.bottom <= 0 || buy.top >= (viewport?.height || window.innerHeight))
          : buy.bottom <= 0);
      const show = allowed && !overlay && !keyboard && this.__form?.isConnected && visible(this.__form) && passedTrigger;
      if (!show && !this.__root.hidden) this.__open(false);
      set(this.__root, 'hidden', !show);
      if (show) css(this.__spacer, 'height', `${this.__root.querySelector('.bossco-sticky-cart__bar').offsetHeight + 16 + (parseFloat(getComputedStyle(this.__root).bottom) || 0)}px`);
    }

    __destroy() {
      if (this.__destroyed) return;
      this.__destroyed = true;
      set(this.__root, 'hidden', true);
      this.__spacer.remove();
      this.__events.abort();
      this.__formObserver?.disconnect();
      this.__pageObserver.disconnect();
      this.__overlayObserver.disconnect();
      this.__resizeObserver?.disconnect();
      this.__heroResizeObserver?.disconnect();
      this.__landingObserver?.disconnect();
      this.__jquery?.(window).off('cc-variant-updated.bosscoStickyCart', this.__variantListener);
      cancelAnimationFrame(this.__frame);
      cancelAnimationFrame(this.__visibilityFrame);
      clearTimeout(this.__timeout);
    }
  }

  function boot() {
    const root = doc.querySelector(selector);
    if (instance?.__root === root && !instance.__destroyed) { instance.__schedule(); return; }
    instance?.__destroy();
    if (root) instance = new StickyCart(root);
  }
  window[key] = { boot };
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  doc.addEventListener('shopify:section:load', boot);
  doc.addEventListener('shopify:block:select', boot);
})();
